import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

export default function useAccessLog() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;

    axios.post('/api/access-log', { path: location.pathname }).catch(() => {});
  }, [location.pathname]);
}
